
















































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class TableActions extends Vue {
  @Prop({ default: true }) editButton!: boolean;
  @Prop({ default: true }) deleteButton!: boolean;
}
